import { DTOUser } from "../users";
import { z } from "zod";
export const DTODesignSystemContactsResponse = z.object({
    contacts: z.object({
        workspace: z.array(DTOUser),
        designSystem: z.array(DTOUser),
    }),
});
